import { ReactNode } from 'react'

import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { SearchParams } from 'shared/ui/search-params'

import s from './styles.module.scss'

interface Props {
  onGoBack?: () => void
  onShowForm?: () => void
  children?: ReactNode
  textDirection?: string
  isDifficultRoute?: boolean
  segments: {
    first: DifficultRoute
    last?: DifficultRoute
  }
}

export const HeaderUi = ({
  children,
  segments,
  textDirection,
  isDifficultRoute,
  onGoBack,
  onShowForm,
}: Props) => {
  return (
    <div>
      <div className={s.headerContainer}>
        <AppIcon
          width={24}
          height={24}
          onClick={onGoBack}
          className={s.icon}
          id={AllIcons.ARROW_LEFT}
        />

        <SearchParams
          onShowForm={onShowForm}
          firstSegment={segments?.first}
          lastSegment={segments?.last}
          textDirection={textDirection}
          isDifficultRoute={isDifficultRoute}
        />
      </div>

      {children ? children : <div className={s.bottom} />}
    </div>
  )
}
